const clear = () => {
  try {
    sessionStorage.clear();
  } catch (_e) {
    //do nothing. We are in a browser environment and sessionStorage is not always available
  }
};

export const SessionStorageService = {
  clear,
};
